
import MuseumTourContent from './components/MuseumTourContent';
import { LocaleProvider, initializeLocale } from './contexts/LocaleContext';

const MuseumTour = () => {
  const initialLocale = initializeLocale();
  return (
    <LocaleProvider initialLocale={initialLocale}>
      <MuseumTourContent />
    </LocaleProvider>
  );
};

export default MuseumTour;
